import React from 'react';
import imgPlaceholder from '../../images/imgPlaceholder.svg';

type Props = {
  className?: string;
};

const ImagePlaceholder = ({ className }: Props) => {
  return (
    <div
      className={`flex items-center justify-center bg-rgrey-lightlight h-full w-full ${className}`}
      role="img"
      aria-label="image placeholder"
    >
      <img src={imgPlaceholder} alt="Rademar" />
    </div>
  );
};

export default ImagePlaceholder;
